
import saMessages from '../locales/he_HE';

const saLang = {
    messages: {
        ...saMessages
    },
    locale: 'he-he',
  
};
export default saLang;